import {
  FETCH_ERROR,
  FETCH_START,
  FETCH_SUCCESS,
  FETCH_RESET,
  HIDE_MESSAGE,
  SHOW_MESSAGE,
  CLEAR_IS_USER_CHECK
} from 'src/constants/ActionTypes';
import Helper from 'src/helpers';
import { messages } from 'src/constants/messages';
import MessageStatus from 'src/util/MessageStatus';

const INIT_STATE = {
  error: "",
  loading: false,
  message: '',
  data: {},
  item: {},
  getName: '',
  domain: '',
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {

    case FETCH_START: {
      return { ...state, error: '', message: '', loading: true, getName: '', domain: action.domain };
    }
    case FETCH_SUCCESS: {
      /**
       * Thông báo (action.apiType) ---
       * LIST: Fetch danh sách
       * ADD: Thêm mới
       * EDIT: Sửa
       * DELETE: Xoá
       * DETAIL: Chi tiết
       * Status trả về (action.status) ---
       * 400: Trùng
       * 404: Dịch vụ không tồn tại
       * 417: Dữ liệu không tồn tại
       * 500: Lỗi dữ liệu
       * 504: Gateway Time-out
       */
      const responseStatus = action.status;
      if (responseStatus === 200 || responseStatus === 201) {
        const apiType = action.apiType;
        if (apiType === 'LIST') {
          if (action.getName) {
            state[action.getName] = {};
            state[action.getName] = action.data;
            state.getName = action.getName;
          } else {
            state.data = action.data;
          }
          return { ...state, error: '', message: '', loading: false };
        }
        if (apiType === 'ADD') {
          // Message thêm mới
          Helper.alertSuccessMessage(messages.THEM_THANH_CONG);
          if (action.getName) {
            state[action.getName] = {};
            state[action.getName] = action.data;
            state.getName = action.getName;
            state.message = messages.THEM_THANH_CONG;
          } else {
            state.data = action.data;
            state.message = messages.THEM_THANH_CONG;
            state.loading = false;
          }
          return { ...state, error: '', message: messages.THEM_THANH_CONG, loading: false };
        }
        if (apiType === 'SEND') {
          // Message send
          Helper.alertSuccessMessage(messages.GUI_THANH_CONG);
          return { ...state, error: '', message: messages.GUI_THANH_CONG, loading: false };
        }
        if (apiType === 'NOTMESSAGE') {
          // Message send
          return { ...state, error: '', message: messages.GUI_THANH_CONG, loading: false };
        }
        if (apiType === 'APPROVED') {
          // Message approved
          Helper.alertSuccessMessage(messages.DUYET_THANH_CONG);
          return { ...state, error: '', message: messages.DUYET_THANH_CONG, loading: false };
        }
        if (apiType === 'DELETE') {
          // Message xoá thành công
          if (action.getName) {
            state[action.getName] = {};
            state[action.getName] = action.data;
            state.getName = action.getName;
            state.message = messages.XOA_THANH_CONG
            state.loading = false;
          } else {
            state.message = messages.XOA_THANH_CONG;
            state.loading = false;
          }
          Helper.alertSuccessMessage(messages.XOA_THANH_CONG);
          return { ...state, error: '', message: messages.XOA_THANH_CONG, loading: false };
        }
        if (apiType === 'EDIT') {
          Helper.alertSuccessMessage(messages.CAP_NHAT_THANH_CONG);
          if (action.getName) {
            state[action.getName] = {};
            state[action.getName] = action.data;
            state.getName = action.getName;
            state.message = messages.CAP_NHAT_THANH_CONG;
          } else {
            state.data = action.data;
            state.message = messages.CAP_NHAT_THANH_CONG;
            state.loading = false;
          }
          return { ...state, error: '', message: messages.CAP_NHAT_THANH_CONG, loading: false };
        }
        if (apiType === 'DETAIL') {
          return { ...state, error: '', message: '', loading: false, item: action.data };
        }
      } else {
        MessageStatus(responseStatus);
        state.loading = false;
        state.message = messages.LUU_THAT_BAI;
        return { ...state, error: '', message: messages.LUU_THAT_BAI, loading: false };
      }
      return { ...state };
    }
    case FETCH_ERROR: {
      return { ...state, error: action.payload, message: '', loading: false };
    }
    case CLEAR_IS_USER_CHECK:
      state.getUserIS = {};
      return { ...state, error: action.payload, message: '', loading: false };
    case SHOW_MESSAGE: {
      return { ...state, error: '', message: action.payload, loading: false };
    }
    case HIDE_MESSAGE: {
      return { ...state, error: '', message: '', loading: false };
    }
    case FETCH_RESET: {
      return INIT_STATE;
    }
    default:
      return state;
  }
}